import { gql } from "graphql-request";

export const DELIVERY_ORDER_EXPORT = gql`
  query DeliveryOrderGenerateExport($input: DeliveryExportGenerateInput) {
    DeliveryOrderGenerateExport(input: $input)
  }
`;
